"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStepbar = exports.StyledStepbarItemWrapper = exports.StyledStepbarItem = exports.StyledStepbarDescription = exports.StyledStepbarSubItem = exports.StyledSubItemDescription = exports.StyledStepbarChevronIcon = exports.StyledStepbarCheckIcon = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const typography_1 = require("../typography");
const utils_2 = require("./utils");
exports.StyledStepbarCheckIcon = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    const { isStepCurrent, isStepCompleted } = props;
    return (0, styled_components_1.css) `
      width: ${theme_1.spacings.s6};
      height: ${theme_1.spacings.s6};
      font-size: ${theme_1.spacings.s3};
      font-weight: bold;
      border-radius: 100%;
      border: 2px solid
        ${isStepCurrent
        ? theme_1.palette.primary.light
        : isStepCompleted
            ? theme_1.palette.grayScale[900]
            : theme_1.palette.grayScale[600]};
      color: ${isStepCurrent
        ? theme_1.palette.grayScale[50]
        : isStepCompleted
            ? theme_1.palette.grayScale[50]
            : theme_1.palette.grayScale[600]};
      background: ${isStepCurrent
        ? theme_1.palette.primary.light
        : isStepCompleted
            ? theme_1.palette.grayScale[900]
            : 'transparent'};

      @media (max-width: 768px) {
        width: ${theme_1.spacings.s5};
        height: ${theme_1.spacings.s5};
      }
    `;
}}
`;
exports.StyledStepbarChevronIcon = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    const { isStepCurrent, isStepCompleted, isOpen } = props;
    return (0, styled_components_1.css) `
      width: ${theme_1.spacings.s6};
      height: ${theme_1.spacings.s6};
      transition: all 0.2s ease-in-out;
      rotate: ${isOpen ? '180deg' : '0deg'};
      svg {
        polyline {
          stroke: ${isStepCurrent
        ? theme_1.palette.primary.light
        : isStepCompleted
            ? theme_1.palette.grayScale[900]
            : theme_1.palette.grayScale[600]};
        }
      }
    `;
}}
`;
exports.StyledSubItemDescription = (0, styled_components_1.default)(typography_1.Typography) `
  margin-top: ${theme_1.spacings.s4};
  padding: ${(0, utils_1.pxToRem)(6)} 0 ${(0, utils_1.pxToRem)(6)} ${theme_1.spacings.s8};
  width: 100%;
  transition: all 0.2s ease-in-out;
`;
exports.StyledStepbarSubItem = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ isOpen, isStepCompleted, isSubStepCurrent, isSubStepCompleted, isStepCurrent, isIncompleteDisabled, isBeforeCurrentSubStep, }) => {
    const disableIncomplete = isIncompleteDisabled
        ? isBeforeCurrentSubStep
            ? false
            : true
        : false;
    return (0, styled_components_1.css) `
      cursor: ${disableIncomplete ? 'not-allowed' : 'pointer'};
      transition: all 0.2s ease-in-out;
      height: ${isOpen ? 'auto' : '0px'};
      min-height: ${isOpen ? '32px' : '0px'};
      opacity: ${isOpen ? 1 : 0};
      overflow: hidden;

      ${!isSubStepCurrent &&
        !isSubStepCompleted &&
        !disableIncomplete &&
        (0, styled_components_1.css) `
        &:hover {
          ${exports.StyledSubItemDescription} {
            color: ${theme_1.primary.dark};
          }
        }
      `}

      ${exports.StyledSubItemDescription} {
        color: ${isSubStepCurrent && isStepCurrent
        ? theme_1.palette.primary.light
        : isSubStepCompleted || isStepCompleted
            ? theme_1.palette.grayScale[900]
            : theme_1.palette.grayScale[600]};
      }
    `;
}}
`;
exports.StyledStepbarDescription = (0, styled_components_1.default)(typography_1.Typography) `
  margin: 0;
  padding: 0;
  transition: all 0.2s ease-in-out;
`;
exports.StyledStepbarItem = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    const { isStepCurrent, isStepCompleted, isVertical, isMinimizedLabel, isIncompleteDisabled, isBeforeCurrentStep, } = props;
    const disableIncomplete = isIncompleteDisabled
        ? isBeforeCurrentStep
            ? false
            : true
        : false;
    return (0, styled_components_1.css) `
      cursor: ${disableIncomplete ? 'not-allowed' : 'pointer'};
      vertical-align: middle;
      padding: 4px 0;
      ${exports.StyledStepbarDescription} {
        letter-spacing: ${isMinimizedLabel ? '5px' : 0};
        height: ${isMinimizedLabel ? (0, utils_1.pxToRem)(33) : 'auto'};
        text-transform: ${isVertical ? 'normal' : 'uppercase'};
        font-size: ${isVertical ? theme_1.spacings.s4 : theme_1.spacings.s3};
        font-weight: ${isVertical ? 600 : 700};
        line-height: ${isVertical ? theme_1.spacings.s6 : (0, utils_1.pxToRem)(18)};
      }
      &:not(:first-of-type) {
        margin-left: ${isVertical ? 0 : '2.531rem'};
      }

      ${!isStepCurrent &&
        !isStepCompleted &&
        !disableIncomplete &&
        (0, styled_components_1.css) `
        &:hover {
          ${exports.StyledStepbarDescription} {
            color: ${theme_1.primary.dark};
          }
          ${exports.StyledStepbarCheckIcon} {
            color: ${theme_1.primary.dark};
            border-color: ${theme_1.primary.dark};
          }
          ${exports.StyledStepbarChevronIcon} {
            svg {
              polyline {
                stroke: ${theme_1.primary.dark}};
              }
            }
          }

          &:focus-visible {
            border-radius: 4px;
            box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.main, theme_1.primary.main)};
            color: ${theme_1.palette.primary.dark};
          }
        }
      `}

      ${(0, utils_2.setItemColor)(props)}

      @media (max-width: 768px) {
        margin-left: 0;
      }
    `;
}}
`;
exports.StyledStepbarItemWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ customStyles, isVertical }) => (0, styled_components_1.css) `
    width: ${isVertical ? '100%' : 'auto'};
    transition: all 1s ease-in-out;

    @media (max-width: 768px) {
      margin-left: 0;
    }
    ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}
  `}
`;
exports.StyledStepbar = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ isVertical }) => {
    return (0, styled_components_1.css) `
      min-width: ${isVertical ? (0, utils_1.pxToRem)(208) : 0};
      flex-direction: ${isVertical ? 'column' : 'row'};
      gap: ${isVertical ? theme_1.spacings.s4 : theme_1.spacings.s1};
      justify-content: space-between;
    `;
}}
`;
//# sourceMappingURL=styles.js.map